import {useParams} from "react-router-dom";
import {useReadProductDetailIn} from "./hooks/useReadProductDetailIn";
import Upper from "./features/Upper";
import {productInDetailMapInit, productInDetailSearchParamInit} from "./state";
import {useEffect, useState} from "react";
import TabNav from "./features/TabNav";
import Tab1 from "./features/Tab1";
import Tab2 from "./features/Tab2";
import {ProductInDetailSearchParamType} from "./interface";
import {useForm} from "react-hook-form";
import {useUpdateProductGroup} from "./hooks/useUpdateProductGroup";

export default function ProductInDetail() {
    const {id} = useParams()

    // Tab2(가격정보) 페이지네이션 파라미터
    const [tab2SearchParam, setTab2SearchParam] = useState<ProductInDetailSearchParamType>(productInDetailSearchParamInit)
    const [tab, setTab] = useState("tab-1");

    const {data: productDetail} = useReadProductDetailIn({param: {...tab2SearchParam, newErpProductid: id as string}})
    const {mutate: mutateUpdateProductGroup} = useUpdateProductGroup()

    const {register, handleSubmit, getValues, setValue, watch} = useForm({
        defaultValues: productDetail?.productDetailRes,
    });

    useEffect(() => {
        if (productDetail?.productDetailRes) {
            setValue("newLProductGroupValue", productDetail.productDetailRes.newLProductGroupValue)
            setValue("productExplain", productDetail.productDetailRes.productExplain)
            setValue("outFlag", productDetail.productDetailRes.outFlag)
        }
    }, [productDetail?.productDetailRes]);

    const btnSave = () => {
        mutateUpdateProductGroup({
            "outFlag": getValues("outFlag"),
            "productExplain": getValues("productExplain"),
            "new_erp_productid": productDetail.productDetailRes.newErpProductid,
            "new_l_product_group@odata.bind": getValues("newLProductGroupValue")
        })
    }

    return <>
        <Upper productDetail={productDetail ?? productInDetailMapInit}
               btnSave={btnSave}
               register={register}
               watch={watch}/>

        <TabNav tab={tab} setTab={setTab}/>

        {tab === "tab-1" && <Tab1 productDetail={productDetail ?? productInDetailMapInit}
                                  register={register}
                                  watch={watch}/>}

        {tab === "tab-2" &&
            <Tab2 productDetail={productDetail ?? productInDetailMapInit}
                  tab2SearchParam={tab2SearchParam}
                  setTab2SearchParam={setTab2SearchParam}/>}
    </>
}